import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Helmet } from "react-helmet"
import NewsArticle from "../../partials/NewsArticle"
import BlogByPost from "./BlogByPost"
import BlogByTag from "./BlogByTag"
import BlogByAuthor from "./BlogByAuthor"
import Pagination from "./Pagination"

function BlogList({ data, pageType, pageContext }) {
  const siteSettings = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)

  const siteUrl = siteSettings.site.siteMetadata.siteUrl
  const { previousPagePath, nextPagePath } = pageContext
  const posts = data.allGhostPost.edges

  return (
    <>
      <Helmet>
        {previousPagePath && (
          <link rel="prev" href={`${siteUrl}${previousPagePath}/`} />
        )}
        {nextPagePath && (
          <link rel="next" href={`${siteUrl}${nextPagePath}/`} />
        )}
      </Helmet>

      <section className="relative">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="pt-32 pb-12 md:pt-40 md:pb-20">
            {/*  Articles list headers */}
            {pageType === "blogList" && (
              <BlogByPost {...{ data, pageContext }} />
            )}
            {pageType === "blogByTag" && (
              <BlogByTag {...{ data, pageContext }} />
            )}
            {pageType === "blogByAuthor" && (
              <BlogByAuthor {...{ data, pageContext }} />
            )}

            {/*  Articles list */}
            <div className="max-w-sm mx-auto md:max-w-none ">
              {/*  Articles container */}
              <div
                className="grid gap-12 md:grid-cols-3 md:col-gap-6 md:row-gap-8 items-start"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                {posts &&
                  posts.map(posts => (
                    <NewsArticle {...posts} key={posts.node.id} />
                  ))}
              </div>
            </div>

            {/*  Pagination */}
            <Pagination {...{ pageContext }} />
          </div>
        </div>
      </section>
    </>
  )
}

export default BlogList
